import {Sound} from '../Sound'
import {UIChatPostController} from './UIChatPostController'
import {ChatData} from '@colonist/shared-types'
import {CardEnum} from '@colonist/game-states'

export class UIChatPost {
    static post(container: HTMLDivElement, chatData: ChatData, preventScroll: boolean = false, makeSound: boolean = true, linkEvent: (type: CardEnum) => undefined = () => undefined): HTMLElement {
        const postController = new UIChatPostController(container, chatData, linkEvent)
        if(makeSound) Sound.playSound(Sound.SoundType.MessageNotification)
        if(!preventScroll) container.scrollTop = container.scrollHeight
        return postController.post
    }
}
